import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';

export interface IVerifyEmailVerifcationPinUseCase {
    execute(guid: string): Promise<boolean>;
}

export class VerifyEmailVerifcationPinUseCase implements IVerifyEmailVerifcationPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(guid: string): Promise<boolean> {
        return await this.userRepo.verifyEmailVerifcationPin(guid);
    }
}
